export default "__VITE_ASSET__f07c03ff__"